import angular from 'angular';

angular
  .module('cloudX')
  .controller('EmployeeAccessDialogCtrl', [
    'flySvc',
    '$http',
    'appUrls',
    'close',
    'relationId',
    'invoiceStreamId',
    employeeAccessDialogCtrl,
  ]);

function employeeAccessDialogCtrl(flySvc, $http, appUrls, close, relationId, invoiceStreamId) {
  var vm = this;
  vm.lines = [];

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };

  var url = invoiceStreamId
    ? `${appUrls.api}/api/InvoiceStream/EmployeeAccess?id=${invoiceStreamId}`
    : `${appUrls.api}/Api/Relation/EmployeeAccess/${relationId}`;

  $http.get(url).then(
    function({ data = [] }) {
      vm.lines = data;
    },
    function(error) {
      vm.lines = [];
      showError(error);
    },
  );

  vm.cancel = function() {
    close(null, 500);
  };
}
